module.exports = __webpack_public_path__ + "static/media/logowhite.a2742c19.png";